import store from '@/store';

export function permissionGuard(to, _from, next) {
  if (to.meta.public || !to.meta._userData) return next();

  const { roles: userRoles = [], permissions: userPermissions = [] } =
    store.state.authentication;

  const combined = [...userRoles, ...userPermissions];

  if (to.meta.roles && !to.meta.roles.some(r => combined.includes(r))) {
    return next('/console/getstarted');
  }

  if (to.meta.permissions && !to.meta.permissions.every(p => userPermissions.includes(p))) {
    return next('/console/getstarted');
  }

  return next();
}